(function () {
  Flint.file('mframework/views/facebookPhotos.js', function (require) {
    Flint.staticStyles('FacebookPhotos', {
      '$loading': '#_flintapp loading.FacebookPhotos, #_flintapp .FacebookPhotos.loading, #_flintapp .ViewFacebookPhotos.loading, #_flintapp .FacebookPhotos > .loading',
      '$Loader': '#_flintapp .ViewFacebookPhotos .ViewLoader',
      '$photosSection': '#_flintapp photosSection.FacebookPhotos, #_flintapp .FacebookPhotos.photosSection, #_flintapp .ViewFacebookPhotos.photosSection, #_flintapp .FacebookPhotos > .photosSection',
      '$photoSection': '#_flintapp photoSection.FacebookPhotos, #_flintapp .FacebookPhotos.photoSection, #_flintapp .ViewFacebookPhotos.photoSection, #_flintapp .FacebookPhotos > .photoSection',
      '$FacebookPhotoImage': '#_flintapp .ViewFacebookPhotos .ViewFacebookPhotoImage'
    }, {
      '$loading': {
        fontSize: 12,
        color: '#999'
      },
      '$Loader': {
        marginTop: 20
      },
      '$photosSection': {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
      },
      '$photoSection': {
        margin: 10,
        cursor: 'pointer'
      },
      '$FacebookPhotoImage': {
        border: '1px solid #ddd'
      }
    });
    Flint.view('FacebookPhotos', function (view, on, $) {
      var fbPhotos = M.listAtom();
      var selectedPhoto = M.mapAtom(null);

      selectedPhoto.reactor(function (photo) {
        if (view.props.onSelect) {
          view.props.onSelect({ photo: photo.toJS() });
        }
      }).start();

      on.mount(function () {
        FB.api('/me/photos', 'GET', {
          fields: 'images',
          limit: 200
        }, function (response) {
          fbPhotos.set(response.data);
        });
      });view.render(function () {
        return Flint.iff(fbPhotos.get() === undefined) && view.el(
          ['loading', 1],
          { if: fbPhotos.get() === undefined },
          'Loading Facebook photos...',
          view.el(['Loader', 1], null)
        );
      });view.render(function () {
        return Flint.iff(fbPhotos.get()) && view.el(
          ['photosSection', 1],
          { if: fbPhotos.get() },
          Flint.range(fbPhotos.get()).map(function (_, _index) {
            return view.el(
              ['photoSection', 1, _, _index],
              {
                repeat: fbPhotos.get(),
                onClick: function () {
                  return selectedPhoto.set(_);
                }
              },
              view.el(['FacebookPhotoImage', 1, _, _index], {
                photo: _,
                width: 200,
                height: 200
              })
            );
          })
        );
      });

      'fbaef0a0';
      '5037db5a';
    });
  })
})();
//# sourceMappingURL=facebookPhotos.js.map
